import "core-js/modules/es.array.join.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "relatorio-inadimplencia"
  }, [_vm._m(0), _c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.gerarRelatorio.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipo",
      "label-for": "inadimplencia-tipo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "inadimplencia-tipo",
      "options": _vm.tipos
    },
    model: {
      value: _vm.filtros.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "tipo", $$v);
      },
      expression: "filtros.tipo"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data inicial",
      "label-for": "inadimplencia-inicio"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "inadimplencia-inicio",
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_inicial,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_inicial", $$v);
      },
      expression: "filtros.data_inicial"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data final",
      "label-for": "inadimplencia-fim"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "inadimplencia-fim",
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_final,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_final", $$v);
      },
      expression: "filtros.data_final"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Faixa de atraso",
      "label-for": "inadimplencia-faixa"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "inadimplencia-faixa",
      "options": _vm.faixas
    },
    model: {
      value: _vm.filtros.faixa_atraso,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "faixa_atraso", $$v);
      },
      expression: "filtros.faixa_atraso"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente ou parceiro"
    }
  }, [_c('VueSelect', {
    attrs: {
      "options": _vm.pessoas,
      "filterable": false,
      "label": "nome",
      "placeholder": "Digite ao menos 3 caracteres"
    },
    on: {
      "input": _vm.selecionarPessoa,
      "search": _vm.buscarPessoa
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('strong', [_vm._v(_vm._s(option.nome))]), option.cnpj_cpf ? _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(" " + _vm._s(option.cnpj_cpf) + " ")]) : _vm._e()];
      }
    }]),
    model: {
      value: _vm.pessoaSelecionada,
      callback: function callback($$v) {
        _vm.pessoaSelecionada = $$v;
      },
      expression: "pessoaSelecionada"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Digite o nome ou documento da pessoa ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor mínimo em atraso",
      "label-for": "inadimplencia-minimo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "inadimplencia-minimo",
      "type": "number",
      "min": "0",
      "step": "0.01",
      "placeholder": "0,00"
    },
    model: {
      value: _vm.filtros.valor_minimo,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "valor_minimo", _vm._n($$v));
      },
      expression: "filtros.valor_minimo"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex flex-wrap justify-content-end mt-2"
  }, [_c('b-button', {
    staticClass: "ml-2 mb-2 px-5",
    attrs: {
      "size": "sm",
      "variant": "primary",
      "type": "submit",
      "disabled": _vm.loading || !!_vm.exportando
    }
  }, [_vm.loading ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Gerar relatório ")], 1), _c('b-button', {
    staticClass: "ml-2 mb-2 px-5",
    attrs: {
      "size": "sm",
      "variant": "outline-success",
      "type": "button",
      "disabled": _vm.loading || !!_vm.exportando
    },
    on: {
      "click": _vm.exportarXlsx
    }
  }, [_vm.exportando === 'xlsx' ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Exportar XLSX ")], 1), _c('b-button', {
    staticClass: "ml-2 mb-2 px-5",
    attrs: {
      "size": "sm",
      "variant": "outline-danger",
      "type": "button",
      "disabled": _vm.loading || !!_vm.exportando
    },
    on: {
      "click": _vm.abrirPdf
    }
  }, [_vm.exportando === 'pdf' ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Imprimir PDF ")], 1)], 1)], 1)], 1)]), _c('b-alert', {
    staticClass: "mb-5",
    attrs: {
      "show": !!_vm.erro,
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.erro) + " ")]), _vm.loading && !_vm.dados ? _c('div', {
    staticClass: "text-center py-15"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  }), _c('p', {
    staticClass: "text-muted mt-3"
  }, [_vm._v("Calculando a inadimplência...")])], 1) : _vm.dados ? [_c('b-row', [_c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "card card-custom h-100"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "text-uppercase font-weight-bolder text-muted mb-3"
  }, [_vm._v(" Inadimplência total ")]), _c('div', {
    staticClass: "display-4 font-weight-bolder text-primary mb-3"
  }, [_vm._v(" " + _vm._s(_vm.moeda(_vm.dados.resumo.valor_total)) + " ")]), _c('div', {
    staticClass: "text-dark-50 line-height-lg"
  }, [_vm._v(" " + _vm._s(_vm.inteiro(_vm.dados.resumo.quantidade_titulos)) + " títulos vencidos"), _c('br'), _vm._v(" " + _vm._s(_vm.inteiro(_vm.dados.resumo.quantidade_inadimplentes)) + " inadimplentes ")])])])]), _c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "card card-custom h-100"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "text-uppercase font-weight-bolder text-muted mb-3"
  }, [_vm._v(" Cliente final ")]), _c('div', {
    staticClass: "display-4 font-weight-bolder text-info mb-3"
  }, [_vm._v(" " + _vm._s(_vm.moeda(_vm.dados.cliente_final.valor_vencido)) + " ")]), _c('div', {
    staticClass: "text-dark-50 line-height-lg"
  }, [_c('strong', [_vm._v(_vm._s(_vm.percentual(_vm.dados.cliente_final.percentual_total)))]), _vm._v(" da inadimplência total"), _c('br'), _vm._v(" Taxa de inadimplência: " + _vm._s(_vm.percentual(_vm.dados.cliente_final.taxa_inadimplencia))), _c('br'), _vm._v(" " + _vm._s(_vm.inteiro(_vm.dados.cliente_final.quantidade_inadimplentes)) + " clientes ")])])])]), _c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "card card-custom h-100"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "text-uppercase font-weight-bolder text-muted mb-3"
  }, [_vm._v(" Parceiros ")]), _c('div', {
    staticClass: "display-4 font-weight-bolder text-warning mb-3"
  }, [_vm._v(" " + _vm._s(_vm.moeda(_vm.dados.parceiros.valor_vencido)) + " ")]), _c('div', {
    staticClass: "text-dark-50 line-height-lg"
  }, [_c('strong', [_vm._v(_vm._s(_vm.percentual(_vm.dados.parceiros.percentual_total)))]), _vm._v(" da inadimplência total"), _c('br'), _vm._v(" Taxa de inadimplência: " + _vm._s(_vm.percentual(_vm.dados.parceiros.taxa_inadimplencia))), _c('br'), _vm._v(" " + _vm._s(_vm.inteiro(_vm.dados.parceiros.quantidade_inadimplentes)) + " parceiros ")])])])])], 1), !_vm.temDados ? _c('b-alert', {
    staticClass: "text-center border py-8",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_vm._v(" Nenhuma inadimplência foi encontrada para os filtros informados. ")]) : [_c('b-row', [_c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "card card-custom h-100"
  }, [_c('div', {
    staticClass: "card-header border-0"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h3', {
    staticClass: "card-label"
  }, [_vm._v("Composição da inadimplência")])])]), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('div', {
    staticClass: "mb-7"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between mb-2"
  }, [_c('strong', [_vm._v("Clientes finais")]), _c('strong', [_vm._v(_vm._s(_vm.percentual(_vm.dados.cliente_final.percentual_total)))])]), _c('b-progress', {
    attrs: {
      "max": 100,
      "height": "14px"
    }
  }, [_c('b-progress-bar', {
    attrs: {
      "value": _vm.percentualSeguro(_vm.dados.cliente_final.percentual_total),
      "variant": "info"
    }
  })], 1)], 1), _c('div', {
    staticClass: "mb-7"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between mb-2"
  }, [_c('strong', [_vm._v("Parceiros")]), _c('strong', [_vm._v(_vm._s(_vm.percentual(_vm.dados.parceiros.percentual_total)))])]), _c('b-progress', {
    attrs: {
      "max": 100,
      "height": "14px"
    }
  }, [_c('b-progress-bar', {
    attrs: {
      "value": _vm.percentualSeguro(_vm.dados.parceiros.percentual_total),
      "variant": "warning"
    }
  })], 1)], 1)])])]), _c('b-col', {
    staticClass: "mb-5",
    attrs: {
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "card card-custom h-100"
  }, [_c('div', {
    staticClass: "card-header border-0"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h3', {
    staticClass: "card-label"
  }, [_vm._v("Inadimplência por tempo de atraso")])])]), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('b-table', {
    attrs: {
      "small": "",
      "responsive": "",
      "hover": "",
      "items": _vm.dados.aging,
      "fields": _vm.camposAging
    },
    scopedSlots: _vm._u([{
      key: "cell(cliente_final)",
      fn: function fn(row) {
        return [_vm._v(_vm._s(_vm.moeda(row.value)))];
      }
    }, {
      key: "cell(parceiros)",
      fn: function fn(row) {
        return [_vm._v(_vm._s(_vm.moeda(row.value)))];
      }
    }, {
      key: "cell(total)",
      fn: function fn(row) {
        return [_c('strong', [_vm._v(_vm._s(_vm.moeda(row.value)))])];
      }
    }])
  })], 1)])])], 1), _c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('h3', {
    staticClass: "card-label"
  }, [_vm._v("Inadimplentes")])])]), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('b-table', {
    attrs: {
      "responsive": "",
      "hover": "",
      "show-empty": "",
      "empty-text": "Nenhum inadimplente encontrado.",
      "items": _vm.inadimplentes,
      "fields": _vm.camposInadimplentes
    },
    scopedSlots: _vm._u([{
      key: "cell(tipo)",
      fn: function fn(row) {
        return [_c('b-badge', {
          attrs: {
            "variant": row.value === 'CLIENTE_FINAL' ? 'info' : 'warning'
          }
        }, [_vm._v(" " + _vm._s(_vm.rotuloTipo(row.value)) + " ")])];
      }
    }, {
      key: "cell(vendedores)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s((row.value || []).join(", ") || "-") + " ")];
      }
    }, {
      key: "cell(vencimento_mais_antigo)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.data(row.value)) + " ")];
      }
    }, {
      key: "cell(dias_maior_atraso)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.inteiro(row.value)) + " dias ")];
      }
    }, {
      key: "cell(valor_vencido)",
      fn: function fn(row) {
        return [_c('strong', [_vm._v(_vm._s(_vm.moeda(row.value)))])];
      }
    }, {
      key: "cell(percentual_sobre_total)",
      fn: function fn(row) {
        return [_vm._v(" " + _vm._s(_vm.percentual(row.value)) + " ")];
      }
    }, {
      key: "cell(acoes)",
      fn: function fn(row) {
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary",
            "disabled": row.item.carregandoTitulos || !row.item.id
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.alternarTitulos(row.item, row.toggleDetails);
            }
          }
        }, [row.item.carregandoTitulos ? _c('b-spinner', {
          attrs: {
            "small": ""
          }
        }) : _c('span', [_vm._v(_vm._s(row.detailsShowing ? "Ocultar" : "Ver títulos"))])], 1)];
      }
    }, {
      key: "row-details",
      fn: function fn(row) {
        return [_c('div', {
          staticClass: "bg-light rounded p-4"
        }, [row.item.erroTitulos ? _c('b-alert', {
          attrs: {
            "show": "",
            "variant": "danger"
          }
        }, [_vm._v(" " + _vm._s(row.item.erroTitulos) + " ")]) : _c('b-table', {
          attrs: {
            "small": "",
            "responsive": "",
            "show-empty": "",
            "empty-text": "Nenhum título encontrado.",
            "items": row.item.titulos || [],
            "fields": _vm.camposTitulos
          },
          scopedSlots: _vm._u([{
            key: "cell(vendedora)",
            fn: function fn(titulo) {
              return [_vm._v(" " + _vm._s(titulo.value || "-") + " ")];
            }
          }, {
            key: "cell(data_vencimento)",
            fn: function fn(titulo) {
              return [_vm._v(" " + _vm._s(_vm.data(titulo.value)) + " ")];
            }
          }, {
            key: "cell(dias_atraso)",
            fn: function fn(titulo) {
              return [_vm._v(" " + _vm._s(_vm.inteiro(titulo.value)) + " dias ")];
            }
          }, {
            key: "cell(saldo)",
            fn: function fn(titulo) {
              return [_c('strong', [_vm._v(_vm._s(_vm.moeda(titulo.value)))])];
            }
          }], null, true)
        })], 1)];
      }
    }])
  })], 1)])]] : _vm._e()], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-5"
  }, [_c('div', [_c('h2', {
    staticClass: "font-weight-bolder mb-1"
  }, [_vm._v("Relatório de Inadimplência")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v(" Compare clientes finais e parceiros por saldo vencido. ")])])]);
}];
export { render, staticRenderFns };